import { render, staticRenderFns } from "./bkRelation.vue?vue&type=template&id=62dbc55a&scoped=true"
import script from "./bkRelation.vue?vue&type=script&lang=js"
export * from "./bkRelation.vue?vue&type=script&lang=js"
import style0 from "./bkRelation.vue?vue&type=style&index=0&id=62dbc55a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dbc55a",
  null
  
)

export default component.exports